<div class="flex justify-content-between">
  <div>
    <CustomTitle *ngIf="header.title" [title]="header.title" [styleClass]="header.class" [showTag]="false"/>
  </div>
  <div class="flex justify-content-end gap-2">
    <div *ngIf="customBtn1">
      <button pButton [label]="customBtn1.label ?? ''" [icon]="customBtn1.icon ?? ''" (click)="customBtn1.onClick($event)"
              [class]=" customBtn1.class ?? 'p-button-outlined'" [severity]="customBtn1.severity?? 'primary'"></button>
    </div>
    <div *ngIf="header.onCreate" CustomCreateButton (onClick)="onCreate()" [disabledBtn]="disabled"
      [pTooltip]="tooltip ? tooltip.message :'msg.btnDeshabilitado' | translate" [tooltipDisabled]="!disabled" tooltipPosition="top">
    </div>
    <div *ngIf="dropdownSelect" class="flex align-content-center align-items-center gap-2"
      [pTooltip]="dropdownSelect.tooltip ? dropdownSelect.tooltip.message :'msg.btnDeshabilitado' | translate" [tooltipDisabled]="!dropdownSelect.disabled" tooltipPosition="top">
        <p-dropdown [options]="dropdownSelect.data" appendTo="body" placeholder="Seleccionar..."
          [(ngModel)]="selected" [optionLabel]="dropdownSelect.label" [filter]="true" [disabled]="dropdownSelect.disabled ?? false">
        </p-dropdown>
        <button pButton type="button" [label]="dropdownSelect.BtnLabel ?? 'common.agregar' | translate" icon="pi pi-plus" (click)="onBtnClick($event)"
          [disabled]="dropdownSelect.disabled" class="button-edit p-button-outlined"></button>
    </div>
  </div>
</div>
